export const userMenuOptions = [
  // { id: 1, label: 'ROLE', separator: true, action: undefined },
  { id: 2, label: 'user.menu.changeUser', separator: false, action: 'changeUser' },
  { id: 3, label: 'user.menu.logOut', separator: false, action: 'logOut' },
];
